import _typeof from "@babel/runtime/helpers/esm/typeof";

/* eslint-disable new-cap */

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 14:11:32
 * @LastEditTime: 2021-01-07 15:02:46
 */
// ====start  milo调用后必须要执行的一些逻辑
// =======================全局处理类逻辑========================
import loader from './loader';
import url from './url';
import frontMonitor from '../biz/frontMonitor';
import ATM from '../util/atm';
import { isString, isObject } from './base';
var MiloInit = {
  "do": function _do() {
    if (!window.miloCoreInitOnce) {
      this.initConsole();
      this.initGlobal(); // add by weiztang 20221014 测试参数下屏蔽上报逻辑

      if (url.request('milodev') !== '1') {
        this.initFrontMonitor();
        this.initATM();
        this.initEAS();
      }

      this.initMiloDebug();
      window.miloCoreInitOnce = true;
    }
  },
  // 1.console兼容
  // desp:milo的所有js组件中可能有部分在调用console.log方法，
  // 此方法在低版本IE下无效，并会导致报错，导致页面逻辑出问题,
  // 为了避免这类问题，需做console.log兼容，为没有console.log方法
  // 的浏览器添加此方法
  initConsole: function initConsole() {
    if ('object' !== _typeof(window.console)) {
      window.console = {};
    }

    if ('function' !== typeof window.console.log) {
      window.console.log = function () {};
    }
  },
  // 2.接入EAS上报逻辑
  // desc:milo接入EAS上报，由milo.js作为入口，自动引入ossweb-img.qq.com/images/js/eas/eas.js
  // 此上报逻辑，在后续milo的模块中可以直接调用相关方法进行上报，引入后，也会自动触发默认曝光
  initEAS: function initEAS() {
    loader.loadScript("".concat(location.protocol, "//ossweb-img.qq.com/images/js/eas/eas.js")).then(function () {// console.log('EAS上报加载成功');
    })["catch"](function (err) {
      console.warn('EAS上报加载失败', err);
    });
  },
  // 3.前端监控
  // desc:milo接入前端监控
  // 默认自动执行初始化，开发者可以传window.No_FrontMonitor_Auto 取消自启动，后续自己启动，以便传自定义参数
  // 注意：window.No_FrontMonitor_Auto=true  必须写在milo.js之前
  initFrontMonitor: function initFrontMonitor() {
    if (!window.No_FrontMonitor_Auto) {
      frontMonitor.init();
    } else {
      // 只监控milo相关的异常数据
      frontMonitor.initForMilo();
    }
  },
  // 4.上报访问
  initATM: function initATM() {
    setTimeout(function () {
      ATM.reportVisit();
    }, 5000);
  },
  // 5.加载全局模块文件
  initGlobal: function initGlobal() {
    loader.loadScript("".concat(location.protocol, "//ossweb-img.qq.com/images/js/miloweb/global.js")).then(function () {// console.log('MiloGlobal加载成功');
    })["catch"](function (err) {
      console.warn('MiloGlobal加载失败', err);
    });
  },
  // 6.支持前端调试miloDebug
  initMiloDebug: function initMiloDebug() {
    if (url.request('sMiloDebugToken')) {
      loader.loadScript('https://ossweb-img.qq.com/images/js/miloweb/debug/latest/miloDebug.js').then(function (isLoad) {
        if (isLoad && !window.MiloDebug && miloDebug) {
          window.MiloDebug = {
            instance: new miloDebug(),
            // 上报jsonp请求数据
            setJsonp: function setJsonp(url, response) {
              var res = response;

              if (!isString(response)) {
                try {
                  res = JSON.stringify(response);
                } catch (err) {
                  console.log('[miloDebug]jsonp stringify error', err);
                }
              }

              this.instance["do"]('network.setJsonpResponse', url, res);
            },
            setXhr: function setXhr(oXhrData) {
              if (isObject(oXhrData)) {
                var _url = oXhrData.url;
                var sResponseText = oXhrData.sResponseText;
                var method = oXhrData.method;

                if (!isString(sResponseText)) {
                  try {
                    sResponseText = JSON.stringify(sResponseText);
                  } catch (err) {
                    console.log('[miloDebug]setXhr stringify error', err);
                  }
                }

                this.instance["do"]('network.setXhrResponse', {
                  url: _url,
                  response: sResponseText,
                  method: method
                });
              }
            }
          };
        }
      })["catch"](function (err) {
        console.warn('[miloDebug]load error', err);
      });
    }
  }
};
export default MiloInit;